import SaveTomaFisica from "../../shared/save_toma_fisica/SaveTomaFisica";

export default function CreateTomaFisicaPage() {


  return (
    <SaveTomaFisica
      enabledFilter={false}
      title="Crear Toma Fisica"
    />
  )

}